var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vv-wrapper"},[_c('el-container',[_c('navbar'),_c('el-container',{attrs:{"direction":"vertical"}},[_c('appbar'),_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }